import React from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Inicio', href: '/' },
  { label: 'Productos', href: '/productos' },
  { label: 'Nosotros', href: '/nosotros' },
  { label: 'Contacto', href: '/contacto' },
];

const marcas = [
  { label: 'Motorola', href: '/productos' },
  { label: 'Hytera', href: '/productos' },
  { label: 'Kenwood', href: '/productos' },
  { label: 'Sepura', href: '/productos' },
  { label: 'TXPRO', href: '/productos' },
  { label: 'Wings', href: '/productos' },
];

const servicios = [
  { label: 'Venta de Equipos', href: '/productos' },
  { label: 'Arriendo de Radios', href: '/servicios/arriendo-de-radios' },
  { label: 'Servicio Técnico', href: '/servicios/servicio-tecnico' },
  { label: 'Solicitar Cotización', href: '/servicios/cotizacion' },
];

function Footer() {
  return (
    <footer className="bg-[#0a1e3d]">
      {/* Línea cian superior */}
      <div className="h-0.5 w-full bg-gradient-to-r from-transparent via-[#00BEE7] to-transparent" />

      {/* CTA strip */}
      <div className="border-b border-white/8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="text-white font-extrabold text-lg">¿Listo para mejorar tu comunicación?</p>
            <p className="text-gray-400 text-sm mt-0.5">Habla con un asesor y recibe orientación sin costo.</p>
          </div>
          <div className="flex gap-3 shrink-0">
            <Link
              to="/contacto"
              className="bg-[#00BEE7] hover:bg-[#00a8cf] text-[#0f274b] font-extrabold text-sm px-5 py-2.5 rounded-full transition-all duration-200"
            >
              Contactar ahora
            </Link>
            <Link
              to="/servicios/cotizacion"
              className="border border-white/25 hover:border-[#00BEE7] text-white hover:text-[#00BEE7] font-bold text-sm px-5 py-2.5 rounded-full transition-all duration-200"
            >
              Cotizar
            </Link>
          </div>
        </div>
      </div>

      {/* Contenido principal */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">

        {/* Columna: Logo + descripción + contacto */}
        <div className="lg:col-span-2 space-y-5">
          <Link to="/" className="inline-block">
            <img
              src="https://dps2wxsijib8x.cloudfront.net/atst/ATST-BLANCO.png"
              alt="ATST Radiocomunicaciones"
              className="h-12 w-auto object-contain"
            />
          </Link>
          <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
            Soluciones integrales de radiocomunicación en Chile para empresas e industrias.
          </p>
          {/* Contacto directo */}
          <div className="space-y-2.5">
            <a
              href="mailto:contacto@atst.cl"
              className="flex items-center gap-3 text-gray-300 hover:text-[#00BEE7] transition-colors duration-200 group"
            >
              <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/8 group-hover:bg-[#00BEE7]/15 transition-colors duration-200 shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </span>
              <span className="text-sm font-medium">contacto@atst.cl</span>
            </a>
            <div className="flex items-start gap-3 text-gray-400">
              <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/8 shrink-0 mt-0.5">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </span>
              <span className="text-sm leading-relaxed">Providencia, Región Metropolitana, Chile</span>
            </div>
          </div>
        </div>

        {/* Columna: Navegación */}
        <div>
          <h4 className="text-[#00BEE7] text-xs font-extrabold uppercase tracking-widest mb-4">Navegación</h4>
          <ul className="space-y-2.5">
            {navLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="text-gray-400 hover:text-white text-sm font-medium transition-colors duration-200 hover:translate-x-0.5 inline-flex items-center gap-1.5 group"
                >
                  <span className="w-1 h-1 rounded-full bg-[#00BEE7]/50 group-hover:bg-[#00BEE7] transition-colors duration-200 shrink-0" />
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Columna: Servicios */}
        <div>
          <h4 className="text-[#00BEE7] text-xs font-extrabold uppercase tracking-widest mb-4">Servicios</h4>
          <ul className="space-y-2.5">
            {servicios.map((s) => (
              <li key={s.href}>
                <Link
                  to={s.href}
                  className="text-gray-400 hover:text-white text-sm font-medium transition-colors duration-200 inline-flex items-center gap-1.5 group"
                >
                  <span className="w-1 h-1 rounded-full bg-[#00BEE7]/50 group-hover:bg-[#00BEE7] transition-colors duration-200 shrink-0" />
                  {s.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Columna: Marcas + mapa */}
        <div className="space-y-6">
          <div>
            <h4 className="text-[#00BEE7] text-xs font-extrabold uppercase tracking-widest mb-4">Marcas</h4>
            <div className="flex flex-wrap gap-2">
              {marcas.map((m) => (
                <Link
                  key={m.label}
                  to={m.href}
                  className="px-2.5 py-1 bg-white/8 hover:bg-[#00BEE7]/20 hover:text-[#00BEE7] text-gray-400 rounded-lg text-xs font-semibold transition-all duration-200 border border-white/8 hover:border-[#00BEE7]/40"
                >
                  {m.label}
                </Link>
              ))}
            </div>
          </div>
          {/* Mini mapa */}
          <div>
            <h4 className="text-[#00BEE7] text-xs font-extrabold uppercase tracking-widest mb-3">Ubicación</h4>
            <div className="relative h-32 rounded-xl overflow-hidden border border-white/10 shadow-lg">
              <iframe
                title="Ubicación ATST"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10813.472415431524!2d-70.616614!3d-33.4261!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf63905aaaab%3A0x2bb2f0323592d648!2sPadre%20Mariano%2082%2C%20Oficina%20503%2C%207500026%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e1!3m2!1ses-419!2scl!4v1751904275711!5m2!1ses-419!2scl"
                className="w-full h-full"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-gray-500 text-xs text-center sm:text-left">
            © {new Date().getFullYear()} ATST Radiocomunicaciones. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-1.5 text-gray-600 text-xs">
            <span>Providencia, Región Metropolitana, Chile</span>
            <span className="w-1 h-1 rounded-full bg-gray-600" />
            <span>Lun–Vie 9:00–18:00</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
